import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    if (cart && Number.isFinite(cart.totalQuantity)) {
      document.querySelectorAll('[data-wb-cart-count]').forEach(element => {
        element.textContent = `(${cart.totalQuantity})`;
      });
    }
    if (event.action === 'add' && !detail?.didError) {
      const notice = document.querySelector('[data-wb-cart-notice]');
      if (notice) notice.hidden = false;
    }
  }).catch(() => { /* Native product form owns error messaging. */ });
});
document.addEventListener('click', event => {
  if (event.target.closest('[data-wb-dismiss-cart]')) {
    document.querySelector('[data-wb-cart-notice]').hidden = true;
  }
});
